import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateTimePickerProps from './DateTimePickerProps'

import Animation from '../Common/Animation'
import Month from '../Common/Month'

export default {
    props: DateTimePickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Animation,
        Month
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoDateTimePicker(that.widgetOptions)
        var widget = that.kendoWidget()

        that.$emit('kendowidgetready', widget)

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', widget.value())
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateTimePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateTimePicker/KendoDateTimePickerMixin.js